import ServiceAgreementsList from '../../../components/ServiceAgreement/ServiceAgreementsList';

function Dealers() {
  return <ServiceAgreementsList />;
}

export default Dealers;
